export enum RecordType {
  Lesson = 'Lesson',
  Path = 'Path',
}
